/*
 * Themporium Christmas countdown clock.
 * Drives the brass clock tower in the night scene: four windows count down to Christmas Day
 * (00:00 on 25 December in the visitor's own time), and the clock face shows their real time.
 * Everything is decorative: without this script the tower simply shows dashes.
 */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-tp-clock]');
  if (!roots.length) return;

  var MINUTE_MS = 60000, HOUR_MS = 3600000, DAY_MS = 86400000;
  var announced = '';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  // The next Christmas Day, or today if it is Christmas Day
  function christmas(now) {
    var year = now.getFullYear();
    var start = new Date(year, 11, 25, 0, 0, 0);
    var end = new Date(year, 11, 26, 0, 0, 0);
    if (now >= end) return { time: new Date(year + 1, 11, 25, 0, 0, 0), today: false };
    if (now >= start) return { time: start, today: true };
    return { time: start, today: false };
  }

  function setDigits(root, unit, text) {
    var el = root.querySelector('[data-unit="' + unit + '"]');
    if (!el) return;
    if (el.textContent !== text) {
      el.textContent = text;
      el.classList.toggle('is-small', text.length > 2);
      el.classList.remove('is-rolling');
      void el.getBBox();           // restart the roll animation
      el.classList.add('is-rolling');
    }
  }

  function rotate(root, hand, deg) {
    var el = root.querySelector('[data-hand="' + hand + '"]');
    if (el) el.style.transform = 'rotate(' + deg.toFixed(1) + 'deg)';
  }

  function tick() {
    var now = new Date();
    var target = christmas(now);
    var diff = target.today ? 0 : Math.max(0, target.time - now);
    var d = Math.floor(diff / DAY_MS);
    var h = Math.floor((diff % DAY_MS) / HOUR_MS);
    var m = Math.floor((diff % HOUR_MS) / MINUTE_MS);
    var s = Math.floor((diff % MINUTE_MS) / 1000);

    var secs = now.getSeconds();
    var mins = now.getMinutes();
    var hours = now.getHours() % 12;

    var label = target.today
      ? 'Merry Christmas! A brass clockwork Christmas clock under a full moon.'
      : 'A brass clockwork Christmas countdown clock under a full moon: ' + d + (d === 1 ? ' day' : ' days') + ' and ' + h + (h === 1 ? ' hour' : ' hours') + ' to go.';

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      setDigits(root, 'd', d > 99 ? String(d) : pad(d));
      setDigits(root, 'h', pad(h));
      setDigits(root, 'm', pad(m));
      setDigits(root, 's', pad(s));
      rotate(root, 's', secs * 6);
      rotate(root, 'm', mins * 6 + secs * 0.1);
      rotate(root, 'h', hours * 30 + mins * 0.5);
      var banner = root.querySelector('.tp-clock-banner');
      if (banner) banner.textContent = target.today ? 'MERRY CHRISTMAS' : 'CHRISTMAS COUNTDOWN';
    }

    // Describe the scene to screen readers, but only when the sentence changes (about hourly)
    if (label !== announced) {
      announced = label;
      var svg = roots[0].closest('svg');
      if (svg) svg.setAttribute('aria-label', label);
    }
  }

  tick();
  window.setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
})();
